import z from "zod";
import RemoteCollection from "../utility/remote-collection";

export const SignupListItemSchema = z.object({}).optional();
export const SignupDetailSchema = z.object({
  affiliate: z.string().nullish(),
  type: z.string().nullish(),
  name: z.string().nullish(),
  company: z.string().nullish(),
  email: z.string().nullish(),
  password: z.string().nullish()
}).optional();
export const collection = new RemoteCollection("/api/signup", SignupListItemSchema, SignupDetailSchema);